import React from 'react';
import { InitializedContextCreator } from '../actions/ContextCreators';

// This consumer passes down the main MGP LoadState (OAuth/orchis-token) data once authentication is completed
const connectWithMGPStore = Container => props => (
  <InitializedContextCreator.Consumer>
    {context => <Container {...context} {...props} />}
  </InitializedContextCreator.Consumer>
);

export default connectWithMGPStore;
